<template>
    <ClientFeedbackNotesList :company="company" @refetch="fetchNewCompanies" />
</template>

<script>
export default {
    name: "client-meeting-notes-cell"
}

</script>

<script setup>
import { defineProps, defineEmits } from "vue";
import ClientFeedbackNotesList from './ClientFeedbackNotesList.vue';

defineProps({
    company: Object
})

const emit = defineEmits(['refetch-companies'])

function fetchNewCompanies () {
    emit('refetch-companies')
}

</script>
